/**
 * Feature keys must match the backend registry (Panel\FeatureAnnouncements\FeatureAnnouncementRegistry).
 * Ship dates and eligibility are computed server-side - this is just a typed key list so callers
 * get compile-time safety, plus the translation key convention each key follows.
 */
export type FeatureAnnouncementKey =
    | "registrations_management_category_search"
    | "competitor_results_bracket_sidebar"
    | "edit_event_internal_information_visual_editor"
    | "manage_academy_members_tab"
    | "coach_passes_nav_spotlight"
    | "edit_event_settings_tab"
    | "schedule_management_global_category_search"
    | "event_status_new_private_visibility"
    | "category_manager_add_categories_menu"
    | "manage_organizers_staff_roles"
    | "schedule_management_schedule_picker"
    | "predefined_notifications_notify_competitors_picker"
    | "brackets_listing_share_button"
    | "registered_competitors_starting_lists_button"
    | "tech_accounts_multiple_accounts";

export function titleTranslationKey(key: FeatureAnnouncementKey): string {
    return `feature_announcement.${key}.title`;
}

export function descriptionTranslationKey(key: FeatureAnnouncementKey): string {
    return `feature_announcement.${key}.description`;
}
